<template>
  <div class="w-full flex justify-between space-x-2 xs:space-x-4">
    <label
        v-for="val in scale"
        :key="val"
        :for="`smile-${val}`"
        class="cursor-pointer flex flex-col items-center"
    >
      <input
          type="radio"
          :value="val"
          :checked="value === val"
          :id="`smile-${val}`"
          name="smile-radio"
          class="hidden"
          @click="$emit('change', val)"
      />
      <a-icon
          :component="smiles[val]"
          :class="[
            'smile',
            'smile-' + val,
            {
              'selected': value === val,
              'colored': value === val || (type === 'smilesColorful' && !value),
            }
          ]"
      />
    </label>
  </div>
</template>

<script>
import {
  Smile1,
  Smile2,
  Smile3,
  Smile4,
  Smile5,
} from "../helpers/customIcon"
import themeMixin from "../mixins/theme.mixin";

export default {
  name: "SmileIcons",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    scale: {
      type: Array,
      default: () => [1, 2, 3, 4, 5]
    },
    type: {
      type: String,
      default: 'smilesColorful'
    },
    value: {
      type: Number,
      default: null
    },
  },
  mixins: [themeMixin],
  data() {
    return {
      smiles: {
        1: Smile1,
        2: Smile2,
        3: Smile3,
        4: Smile4,
        5: Smile5,
      }
    }
  }
}
</script>

<style lang="less" scoped>
.smile {
  font-size: 40px;
  color: rgba(187, 187, 187, 0.5);
  transition: all ease-in-out .15s;

  &.selected, &:hover {
    transform: scale(1.05);
  }

  &.colored, &:hover {
    &.smile-1 {
      color: #E40072;
    }

    &.smile-2 {
      color: #FF8743;
    }

    &.smile-3 {
      color: #FAAD14;
    }

    &.smile-4 {
      color: #90AE39;
    }

    &.smile-5 {
      color: #39AE61;
    }
  }
}

@media @v-mobile-xs-break-point {
  .smile {
    font-size: 48px;
  }
}
</style>
```
